import { type PropsWithChildren } from 'react';

import { HistogramInfiniteZoomContext } from './HistogramInfiniteZoom.context.js';
import { HistogramInteractionsProvider } from './HistogramInteractionsProvider.js';
import { HistogramToolbarProvider } from './HistogramToolbarProvider.js';
import { defaultThreshold } from '../constants/defaults.js';
import {
  defaultConfig,
  HistogramAnnotationsConfigContext,
} from '../contexts/HistogramAnnotationsConfig.context.js';
import { HistogramColorPaletteContext } from '../contexts/HistogramColorPalette.context.js';
import { HistogramLegendContext } from '../contexts/HistogramLegend.context.js';
import { HistogramSelectConfigContext } from '../contexts/HistogramSelectConfigContext.js';
import { HistogramThresholdContext } from '../contexts/HistogramThreshold.context.js';
import { HistogramTooltipContext } from '../contexts/HistogramTooltipMode.context.js';
import { HistogramTruncationModeContext } from '../contexts/HistogramTruncationMode.context.js';
import { HistogramValueRepresentationContext } from '../contexts/HistogramValueRepresentation.context.js';
import { HistogramXAxisConfigContext } from '../contexts/HistogramXAxisConfig.context.js';
import { HistogramYAxisConfigContext } from '../contexts/HistogramYAxisConfig.context.js';
import { HistogramZoomRangesContext } from '../contexts/HistogramZoomRanges.js';
import { HistogramChartConfiguration } from '../types/histogram.js';

//TODO: Modify the marker type to accept the ID
export const HistogramConfigProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: HistogramChartConfiguration }>) => (
  <HistogramColorPaletteContext.Provider value={config.colorPalette}>
    <HistogramTruncationModeContext.Provider value={config.truncationMode}>
      <HistogramXAxisConfigContext.Provider value={config.xAxis}>
        <HistogramYAxisConfigContext.Provider value={config.yAxis}>
          <HistogramLegendContext.Provider value={config.legend}>
            <HistogramTooltipContext.Provider value={config.tooltip}>
              <HistogramToolbarProvider config={config.toolbar}>
                <HistogramInteractionsProvider config={config.interactions}>
                  <HistogramInfiniteZoomContext.Provider
                    value={config.infiniteZoom}
                  >
                    <HistogramZoomRangesContext.Provider
                      value={{
                        initialZoom: config.initialZoom,
                        currentZoom: config.currentZoom,
                      }}
                    >
                      <HistogramAnnotationsConfigContext.Provider
                        value={config.annotations || defaultConfig}
                      >
                        <HistogramThresholdContext.Provider
                          value={config.thresholds ?? defaultThreshold}
                        >
                          <HistogramValueRepresentationContext.Provider
                            value={config.valueRepresentation}
                          >
                            <HistogramSelectConfigContext.Provider
                              value={config.select}
                            >
                              {children}
                            </HistogramSelectConfigContext.Provider>
                          </HistogramValueRepresentationContext.Provider>
                        </HistogramThresholdContext.Provider>
                      </HistogramAnnotationsConfigContext.Provider>
                    </HistogramZoomRangesContext.Provider>
                  </HistogramInfiniteZoomContext.Provider>
                </HistogramInteractionsProvider>
              </HistogramToolbarProvider>
            </HistogramTooltipContext.Provider>
          </HistogramLegendContext.Provider>
        </HistogramYAxisConfigContext.Provider>
      </HistogramXAxisConfigContext.Provider>
    </HistogramTruncationModeContext.Provider>
  </HistogramColorPaletteContext.Provider>
);
